<template>
  <section class="hero is-primary is-fullheight">
    <div class="hero-body">
      <div class="container">
        <div class="columns is-centered">
          <div class="column is-5-tablet is-4-desktop is-3-widescreen">
            <form @submit.prevent="login" class="box">
              <div class="field">
                <label for="" class="label">Email</label>
                <div class="control has-icons-left">
                  <input v-model="username" type="email" placeholder="e.g. bobsmith@gmail.com" class="input" required>
                  <span class="icon is-small is-left">
                  <i class="fa fa-envelope"></i>
                </span>
                </div>
              </div>
              <div class="field">
                <label for="" class="label">Password</label>
                <div class="control has-icons-left">
                  <input v-model="password" type="password" placeholder="*******" class="input" required>
                  <span class="icon is-small is-left">
                  <i class="fa fa-lock"></i>
                </span>
                </div>
              </div>
              <div class="field">
                <label for="" class="checkbox">
                  <input type="checkbox">
                  Remember me
                </label>
              </div>
              <div class="field">
                <button type="submit" class="button is-primary">
                  Login
                </button>
              </div>

              <p v-if="error">{{ error }}</p>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {signIn, confirmSignIn, fetchAuthSession} from 'aws-amplify/auth';

export default {
  data() {
    return {
      username: '',
      password: '',
      error: '',
    };
  },
  methods: {
    async login() {

      try {
        const username = this.username
        const password = this.password
        const newpass = null
        const {isSignedIn, nextStep} = await signIn({username, password});


        console.log('User signed in:', isSignedIn);
        console.log("NextStep: ", nextStep)
        // Redirect or save session info

        // Redirect to the main app
        switch (nextStep.signInStep) {

          case 'CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED':
            this.$buefy.dialog.prompt({
              message: `Please choose a new password, min 8 chars `,
              inputAttrs: {
                type: "password",
                placeholder: "",
                minLength: 8
              },
              trapFocus: true,
              onConfirm: value => {
                this.$buefy.toast.open(`Your pass has been changed. Logging in...`)
                confirmSignIn({
                  challengeResponse: value,
                }).then(() => {
                  this.$router.push('/');
                });
              }


            });


          case 'CONFIRM_SIGN_IN_WITH_SMS_CODE':
            // display user to enter otp code;
            break;
          case 'CONFIRM_SIGN_IN_WITH_TOTP_CODE':
            // display user to enter otp code;
            break;
            // ...
        }

        await this.$router.push('/');


      } catch (err) {
        this.error = err.message;
      }
    },
  },
};
</script>
